<template>
  <div>
    <template v-if="$route.name === 'EXSBInvoiceCreate'">
      <b-row>
        <b-col>
          <button @click="$router.go(-1)" class="btn btn-default float-right">{{ $t('buttons.goBack') }}</button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="card">
            <div class="card-body">
              <b-row>
                <b-col>
                  <EXSBInvoiceForm
                          :handle-submit="onSendForm"
                          :handle-update-field="updateField"
                          :values="item"
                          :editType="''"
                          :idFirm="idFirm"/>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </template>
    <template v-else>
      <b-row>
        <b-col>
          <EXSBInvoiceForm
            :handle-submit="onSendForm"
            :handle-update-field="updateField"
            :values="item"
            :editType="''"
            :idFirm="idFirm"/>
        </b-col>
      </b-row>
    </template>
    <ItemCreateModal></ItemCreateModal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import EXSBInvoiceForm from './Form'
import { checkPagePermission } from '@/utils/checkRoles.js'
import ItemCreateModal from '@/components/Dashboard/Views/BusinessBundle/exsbitem/modals/ItemCreateModal'
import ApiService from '@/utils/ApiService'
import moment from 'moment'

const { mapGetters, mapActions } = createNamespacedHelpers('exsbinvoice/create')

export default {
  name: 'Create',
  components: {
    EXSBInvoiceForm,
    ItemCreateModal
  },
  props: ['idFirm'],

  data () {
    return {
      moment,
      item: {
        issueDate: this.$moment().format('YYYY-MM-DD'),
        sellDate: this.$moment().format('YYYY-MM-DD'),
        acceptThoseInvoices: false,
        prepareMailWithInvoice: false,
        invoiceDocumentType: 1,
        totalSums: [],
        invoicePositions: [],
        invoiceType: null,
        paymentWay: null,
        invoiceStatus: null,
        batchNumber: null,
        totalValueNetto: 0,
        totalValueBrutto: 0,
        totalVatAmount: 0,
        toPay: 0,
        paid: 0,
        sellerAccount: '',
        sellerName: '',
        sellerNip: '',
        sellerStreet: '',
        sellerStreetNumber: '',
        sellerPlaceNumber: '',
        sellerCity: '',
        sellerPostcode: '',
        issuePlace: '',
        comments: '',
        buyerNip: '',
        buyerName: '',
        buyerStreet: '',
        buyerCity: '',
        buyerPostcode: '',
        buyerStreetNumber: '',
        buyerPlaceNumber: ''
      }
    }
  },

  computed: mapGetters([
    'error',
    'isLoading',
    'created',
    'violations'
  ]),

  beforeCreate () {
    checkPagePermission('finances', 'EXSBInvoiceCreate')
  },

  watch: {
    isVisible (val) {
      if (!val) {
        this.reset()
      }
    },
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }
      if (this.$route.name === 'EXSBInvoiceCreate') {
        this.$router.push({ name: 'EXSBInvoiceShow', params: { id: created['@id'] } })
      }
    }
  },

  created () {
    this.getAccountNumber()
  },

  methods: {
    async getAccountNumber () {
      const response = await new ApiService('owners/1').getResults()
      this.item.sellerAccount = response.bankAccount
      this.item.sellerName = response.titlePartOne
      this.item.sellerNip = response.nip
      this.item.sellerStreet = response.street
      this.item.sellerStreetNumber = response.place
      this.item.sellerPlaceNumber = response.numberLocal
      this.item.sellerCity = response.city
      this.item.sellerPostcode = response.postcode
      this.item.invoiceDocumentType = response.invoiceSettings.documentType
      this.item.issuePlace = response.invoiceSettings.issuePlace
      this.item.comments = response.invoiceSettings.comments
      this.item.invoiceType = response.invoiceSettings.invoiceType
    },

    ...mapActions([
      'reset',
      'create'
    ]),

    onSendForm () {
      let item = Object.assign({}, this.item)
      for (let p in item.invoicePositions) {
        item.invoicePositions[p].quantity = parseFloat(item.invoicePositions[p].quantity)
        item.invoicePositions[p].priceNettoPerUnit = (item.invoicePositions[p].priceNettoPerUnit).toString()
        item.invoicePositions[p].priceBruttoPerUnit = (item.invoicePositions[p].priceBruttoPerUnit).toString()
        item.invoicePositions[p].valueNetto = (item.invoicePositions[p].valueNetto).toString()
        item.invoicePositions[p].valueBrutto = (item.invoicePositions[p].valueBrutto).toString()
        item.invoicePositions[p].discount = (item.invoicePositions[p].discount).toString()
        item.invoicePositions[p].vatAmount = (item.invoicePositions[p].vatAmount).toString()
      }
      item.paid = item.paid.toString()
      item.toPay = item.toPay.toString()
      item.totalVatAmount = item.totalVatAmount.toString()
      this.create(item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
